import Pages from './pages/Pages'
import PagesView from './pages/View'
import PagesCreate from './pages/Create'
import PageSections from './page-sections/PageSections'
import PageSectionsView from './page-sections/View'
import PageSectionsCreate from './page-sections/Create'
import PageLayout from './page-layout/PageLayout'
import PageBuilder from './page-builder/PageBuilder'

const Modules = {
    Pages,
    PagesView,
    PagesCreate,
    PageSections,
    PageSectionsView,
    PageSectionsCreate,
    PageLayout,
    PageBuilder,
}

export default Modules
